import { Box, Divider, Typography } from '@mui/material'
import React from 'react'
import { useAdmin } from '../AdminContext';
import SubTitle from '../../Public/MainComponents/SubTitle';
import { useMobile } from '../../../base';

export default function AdminCounters() {
    const { counters } = useAdmin() || {};
    const mobile = useMobile();

    const {
        ez_bs,
        ez_ki,
        ez_sh,
        ez_v,
        insurance,
        insurance_img,
        insurance_year,
        insurance_year_img,
        stolen,
        stolen_daily,
        total_day,
        total_month,
        total_year,
    } = counters;

    return (
        <>
            <SubTitle title={'Vyhledávání'} />
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', gap: '12px' }}>
                {Boolean(counters) &&
                    <Box
                        sx={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left', flexDirection: 'column', borderRadius: '20px', border: '1px solid rgba(0, 0, 0, 0.12)', p: '20px' }}>
                        <Typography><b>Dnes celkem:</b> {total_day}</Typography>
                        <br />
                        <Typography><b>Odcizení:</b> {stolen_daily}</Typography>
                        <br />
                        <Divider />
                        <br />
                        <Typography><b>Měsíc celkem:</b> {total_month}</Typography>
                        <br />
                        <Typography><b>Insurance:</b> {insurance}</Typography>
                        <Typography><b>Insurance obrázky:</b> {insurance_img}</Typography>
                        <br />
                        <Typography><b>Ezy vozidlo:</b> {ez_v}</Typography>
                        <Typography><b>Ezy výbava:</b> {ez_bs}</Typography>
                        <Typography><b>Ezy servisy:</b> {ez_sh}</Typography>
                        <br />
                        <Typography><b>Odcizení:</b> {stolen}</Typography>
                        <br />
                        <Divider />
                        <br />
                        <Typography><b>Rok celkem:</b> {total_year}</Typography>
                        <br />
                        <Typography><b>Insurance:</b> {insurance_year}</Typography>
                        <Typography><b>Insurance obrázky:</b> {insurance_year_img}</Typography>
                    </Box>}
            </Box>
        </>
    )
}
